"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BaseButtonStyled = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _constants = require("../constants");
var _getButtonBackgroundColor = require("./getButtonBackgroundColor");
var _getButtonBorder = require("./getButtonBorder");
var _getButtonBorderRadius = require("./getButtonBorderRadius");
var _getButtonFocusRingStyles = require("./getButtonFocusRingStyles");
var _getButtonFontStyles = require("./getButtonFontStyles");
var _getButtonHeight = require("./getButtonHeight");
var _getButtonMinWidth = require("./getButtonMinWidth");
var _getButtonMotion = require("./getButtonMotion");
var _getButtonPadding = require("./getButtonPadding");
var _getButtonTextColor = require("./getButtonTextColor");
var _getButtonTextDecoration = require("./getButtonTextDecoration");
const getCursor = _ref => {
  let {
    state
  } = _ref;
  return state.isDisabled ? "not-allowed" : "pointer";
};
const getWidth = _ref2 => {
  let {
    shouldFitContainer
  } = _ref2;
  return shouldFitContainer ? "100%" : undefined;
};
const getHeight = props => {
  return props.appearance !== "link" ? `${(0, _getButtonHeight.getButtonHeight)(props)}px;` : "auto";
};
const BaseButtonStyled = (0, _styled.default)("button")`
    text-transform: none; // Remove inheritance of text transform in Firefox
    overflow: visible; // Show overflow in Edge
    margin: 0; // Remove margin in Firefox and Safari
    padding: 0; // Remove padding in webkit
    outline: none; // Remove default focus outline in various browsers
    font-family: inherit; // Ensure we inherit from parent since many browsers override this in user-agent stylesheet.

    &::-moz-focus-inner {
        border: 0;
        margin: 0;
        padding: 0;
    }

    display: inline-flex;
    box-sizing: border-box;
    align-items: center;

    height: ${getHeight};
    width: ${getWidth};
    min-width: ${_getButtonMinWidth.getButtonMinWidth};
    max-width: 100%; // if the parent is smaller than the button, we want to truncate
    padding: ${_getButtonPadding.getButtonPadding};
    border-width: 1px;
    border-style: solid;
    border-color: var(${_constants.cssBaseBorderVar}, ${_getButtonBorder.getButtonBorderColor});
    text-align: center;
    border-radius: ${_getButtonBorderRadius.getButtonBorderRadius};
    background-color: var(${_getButtonBackgroundColor.getButtonBackgroundColorVar}, var(${_constants.cssBaseBackgroundVar}, ${_getButtonBackgroundColor.getButtonBackgroundColor}));
    font-size: ${_getButtonFontStyles.getButtonFontSize};
    line-height: ${_getButtonFontStyles.getButtonLineHeight};
    font-weight: ${_getButtonFontStyles.getButtonFontWeight};
    color: var(${_getButtonTextColor.getButtonTextColorVar}, var(${_constants.cssBaseTextVar}, ${_getButtonTextColor.getButtonTextColor}));
    white-space: nowrap;
    cursor: ${getCursor};
    text-decoration: ${_getButtonTextDecoration.getTextDecoration}; // if the href prop is used, an anchor tag will be rendered instead
    position: relative;
    transition: ${_getButtonMotion.getButtonMotion};
    text-underline-offset: ${_getButtonBorder.getUnderlineOffset};
    ${_getButtonFocusRingStyles.getButtonFocusRingStyles}
`;
exports.BaseButtonStyled = BaseButtonStyled;
//# sourceMappingURL=BaseButtonStyled.js.map